// extracted by mini-css-extract-plugin
export default {"footer-layout":"cJTRh","footer-layout-left":"bAocD"};